/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-25 10:40:56
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-25 10:42:43
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/warnning.service.ts
 */
import { useState } from 'react';

function useWarnningService() {
  const [deleteModalVisible, setDeleteVisible] = useState(false);

  return {
    deleteModalVisible,
    setDeleteVisible,
  };
}

export default useWarnningService;
